
import Vue from "vue";
import { PutNurseryRequest } from "@/api/ApiNursery";
import { nurseryModule } from "@/store/dataModule/nurseryModule";
import ValidationMixin from "@/mixins/ValidationMixin";
import LocalDataService from "@/service/LocalDataService";
import DatePicker from "@/components/atoms/DatePicker.vue";

export default Vue.extend({
  mixins: [ValidationMixin],

  components: {
    DatePicker,
  },

  async mounted() {
    if (this.nurseryId) {
      await this.getNursery();
    }
    if (!this.inputValue.firstNameKana) this.inputValue.firstNameKana = 'ア';
    if (!this.inputValue.lastNameKana) this.inputValue.lastNameKana = 'ア';
  },

  data() {
    return {
      isLoading: false,
      isFormValid: false,
      inputValue: {} as PutNurseryRequest,
    };
  },

  computed: {
    nurseryId: function () {
      return this.$route.params.id;
    },
    genderItems: function () {
      return [
        { text: this.$t('schoolDetail.genderMale'), value: "male" },
        { text: this.$t('schoolDetail.genderFemale'), value: "female" },
      ];
    },
    categoryItems: function () {
      return [
        { text: this.$t('schoolDetail.staffGeneral'), value: "general" },
        { text: this.$t('schoolDetail.staffHelper'), value: "help" },
      ];
    },
  },

  methods: {
    async getNursery() {
      this.isLoading = true;
      if (this.nurseryId) {
        const response = await nurseryModule.getNursery({
          nurseryId: this.nurseryId,
        });
        if (response) {
          this.inputValue = response as any;
        }
      }
      this.isLoading = false;
    },
    async updateNursery() {
      this.isLoading = true;
      if (this.inputValue) {
        this.inputValue.category = "general";

        await nurseryModule
          .updateNursery({
            ...this.inputValue,
          })
          .catch((e) => console.warn(e));
        this.$router.push({ path: "/school" });
      }
      this.isLoading = false;
    },
    async createNursery() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId && this.inputValue) {
        this.inputValue.category = "general";

        await nurseryModule
          .createNursery({
            companyId,
            ...this.inputValue,
          })
          .catch(() => (this.isLoading = false));
        this.$router.push({ path: "/school" });
      }
      this.isLoading = false;
    },
  },
});
